import React from 'react'
import Enquiry from '../../Components/enquiry/Enquiry';

const EnquiryPage = () => {
  return (
    <>
      <Enquiry />
    </>
  )
}

export default EnquiryPage;
